<!-- 基本信息table -->
<template>
    <div>
        <el-table border :header-cell-style="{
            backgroundColor: '#FDEFE7', color: '#000000'
        }" :data="tableData" style="width: 100%">
            <el-table-column fixed="left" align="center" prop="orderMainId" label="订单编号" width="180">
            </el-table-column>
            <el-table-column align="center" prop="name" label="下单时间" width="180">
                <template slot-scope="scope">
                    {{ scope.row.createTime | dateFormatHms }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="address" label="用户账号" width="180">

            </el-table-column>
            <el-table-column align="center" prop="name" label="用户昵称 机构名称 用户联系电话" width="200">
                <template slot-scope="scope">
                    <p>用户昵称：{{ scope.row.createName }}</p>
                    <p>机构名：{{ scope.row.createCompanyName }}</p>
                    <p>联系电话：{{ scope.row.phoneNumber }}</p>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="address" label="支付方式">
                <template slot-scope="scope">
                    {{ payModeType[scope.row.payMode] }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="address" label="订单来源">
                <template slot-scope="scope">
                    {{ scope.row.orderType == 0 ? 'pc端订单' : '小程序订单' }}
                </template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="address" label="订单类型">
            </el-table-column> -->
        </el-table>
        <el-table border :header-cell-style="{
            backgroundColor: '#FDEFE7', color: '#000000'
        }" :data="tableData" style="width: 100%">
            <el-table-column fixed="left" align="center" prop="planId" label="行程编号" width="180">
            </el-table-column>
            <el-table-column align="center" prop="budgetMainId" label="预算编号" width="180">
            </el-table-column>
            <el-table-column align="center" prop="address" label="子订单数量" width="180">
                <template slot-scope="scope">
                    <div v-for="(n, m) in scope.row.statusDescription" :key="m"
                        style="font-size: 0.12rem;margin-bottom: 0.05rem;">
                        <span style="color: #3A8477;">{{ n.num }}个子订单</span>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column align="center" prop="name" label="子订单类型" width="180">
            </el-table-column> -->
            <el-table-column align="center" prop="address" label="订单可得积分">
            </el-table-column>
            <el-table-column align="center" prop="address" label="订单可得成长值">
            </el-table-column>
            <el-table-column align="center" prop="address" label="活动信息">
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
export default {
    props: {
        tableData: {
            type: Array,
            default: () => []
        }
    },
    components: {},
    data() {
        return {
            payModeType: {
                0: '微信支付',
                1: '支付宝支付',
                2: '钱包支付',
                3: '线下转帐'
            },
        }
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>